import * as React from "react";
const SvgPauseLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 5H8V19H6V5ZM16 5H18V19H16V5Z", fill: "black" }));
export default SvgPauseLine;
